import { useEffect, useState } from 'react';
import AdminRegisterModal from './AdminRegisterModal';
import LockedPairsModal from './LockedPairsModal';
import AdminPageModal from './AdminPageModal';
import '../css/AdminSidebar.css';

function AdminSidebar({ active = '', groupId, onRefresh }) {
  const [registerOpen, setRegisterOpen] = useState(false);
  const [lockedPairsOpen, setLockedPairsOpen] = useState(false);
  const [pageModal, setPageModal] = useState(null);
  const selectedGroupId = Number(groupId || localStorage.getItem('last_group_id') || 0);
  const embedMode = new URLSearchParams(window.location.search).get('embed') === '1';
  useEffect(() => {
    if (!embedMode) return undefined;
    document.body.classList.add('admin-embed-mode');
    return () => document.body.classList.remove('admin-embed-mode');
  }, [embedMode]);
  const openPage = path => {
    window.open(path, '_blank', 'noopener,noreferrer');
  };
  const go = openPage;
  const items = [
    { key: 'dashboard', icon: '🏠', label: 'Dashboard', action: () => go('/dashboard') },
    { key: 'matches', icon: '🏸', label: 'Group Matches', disabled: !selectedGroupId, action: () => go(`/admin/group/${selectedGroupId}/matches`) },
    { key: 'planner', icon: '✨', label: 'Match Planner', disabled: !selectedGroupId, action: () => openPage(`/match-planner/${selectedGroupId}`) },
    { key: 'create-match', icon: '➕', label: 'จัดแมท', disabled: !selectedGroupId, action: () => setPageModal({ title: 'จัดแมท', url: `/match-planner/${selectedGroupId}?manual=1&embed=1` }) },
    { key: 'lock-pair', icon: '🔒', label: 'Lock Pair', disabled: !selectedGroupId, action: () => setLockedPairsOpen(true) },
    { key: 'game-control', icon: '🎲', label: 'Game Match Control', disabled: !selectedGroupId, action: () => setPageModal({ title: 'Game Match Control', url: `/game-match-control/${selectedGroupId}?embed=1` }) },
    { key: 'monitor', icon: '🖥️', label: 'Admin Monitor', action: () => go('/admin_monitor') },
    { key: 'checkin-qr', icon: '▦', label: 'สร้าง Check-in QR', action: () => setPageModal({ title: 'สร้าง Check-in QR', url: '/admin/checkin-qr?embed=1' }) },
    { key: 'monitor-qr', icon: '📺', label: 'สร้าง QR Monitor', action: () => setPageModal({ title: 'สร้าง QR Monitor', url: '/admin/monitor-qr?embed=1' }) },
    { key: 'users', icon: '🛡️', label: 'ผู้เล่นทั้งหมด', action: () => setPageModal({ title: 'ผู้เล่นทั้งหมด', url: '/admin/users?embed=1' }) },
    { key: 'register', icon: '➕', label: 'ลงทะเบียนสมาชิกเข้ากรุ๊ป', disabled: !selectedGroupId, action: () => setRegisterOpen(true) },
    { key: 'result-logs', icon: '📝', label: 'Result Log', disabled: !selectedGroupId, action: () => setPageModal({ title: 'Result Log', url: `/admin/result-logs?groupId=${selectedGroupId}&embed=1` }) },
    { key: 'rewards', icon: '🎁', label: 'Admin Reward', action: () => setPageModal({ title: 'Admin Reward', url: '/admin/rewards?embed=1' }) }
  ];

  if (embedMode) return null;

  return <><aside className="admin-shared-sidebar" aria-label="เมนูผู้ดูแลระบบ">
    <strong>🏸 Admin<br />Dashboard</strong>
    <nav>{items.map(item => <button type="button" key={item.key} className={active===item.key?'is-active':''} disabled={item.disabled} onClick={item.action}><span>{item.icon}</span>{item.label}</button>)}</nav>
    {onRefresh && <button type="button" className="admin-sidebar-refresh" onClick={onRefresh}>🔄 Refresh</button>}
  </aside>{registerOpen && <AdminRegisterModal groupId={selectedGroupId} onClose={() => setRegisterOpen(false)} />}{lockedPairsOpen && <LockedPairsModal groupId={selectedGroupId} onClose={() => setLockedPairsOpen(false)} />}{pageModal && <AdminPageModal title={pageModal.title} url={pageModal.url} onClose={() => setPageModal(null)} />}</>;
}

export default AdminSidebar;
